import React, { useContext } from "react";
import { AuthContext } from "./AuthContext.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvoiceForm from "./Components/Invoice/InvoiceForm.js";
import LandingPage from "./Components/LandingPage";
import BillOfLadingForm from "./Components/BolForm";
import LoginPage from "./Components/LoginPage";
import CreditCardForm from "./Components/CardForm.js";
import SendCCForm from "./Components/SendCCForm.js";
import InvoiceSummary from "./Components/Invoice/InvoiceSummary/InvoiceFormSummary.js";
import QuoteForm from "./Components/Invoice/QuoteForm/QuoteForm.js";
import QuoteSummary from "./Components/Invoice/InvoiceSummary/QuoteFormSummary.js";
import SpanishQuoteForm from "./Components/Invoice/SpanishQuote/SpanishQuoteForm.js";
import SpanishQuoteSummary from "./Components/Invoice/InvoiceFormSummarySpanish/SpanishQuoteSummary.js";

export default function Routing() {
  const { user } = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/card-form" element={<CreditCardForm />} />
        <Route path="/invoice-summary" element={<InvoiceSummary />} />
        <Route path="/quote-summary" element={<QuoteSummary />} />
        <Route path="/spanish-quote-summary" element={<SpanishQuoteSummary />} />
        <Route
          path="/send-card-form"
          element={user ? <SendCCForm /> : <LoginPage />}
        />
        <Route path="/" element={user ? <LandingPage /> : <LoginPage />} />
        <Route
          path="/invoice"
          element={user ? <InvoiceForm /> : <LoginPage />}
        />
        <Route path="/quote" element={user ? <QuoteForm /> : <LoginPage />} />
        <Route path="/spanish-quote" element={user ? <SpanishQuoteForm /> : <LoginPage />} />
        <Route
          path="/bol"
          element={user ? <BillOfLadingForm /> : <LoginPage />}
        />
      </Routes>
    </BrowserRouter>
  );
}
